import { type CheckboxChangeEvent } from "antd/lib/checkbox";

import { BTCheckbox } from "@btnet/core-components";

import { type KeyOfOrString } from "utilities/type/PropsOfType";

import {
    SpecificationOwnerShareMode,
    SpecificationSubShareMode,
} from "entity/specification/Specification.api.types";

export interface ISpecificationShareProps<FormValues> {
    specificationsText: string;
    onOwnerChange: (field: KeyOfOrString<FormValues>, value: SpecificationOwnerShareMode) => void;
    onSubChange: (field: KeyOfOrString<FormValues>, value: SpecificationSubShareMode) => void;
    notifyOwnerId: KeyOfOrString<FormValues>;
    notifySubId: KeyOfOrString<FormValues>;
    notifyOwnerValue: SpecificationOwnerShareMode | null;
    notifySubValue: SpecificationSubShareMode | null;
    hideTitle?: boolean;
}
export function SpecificationShare<FormValues>(props: ISpecificationShareProps<FormValues>) {
    const {
        onOwnerChange,
        onSubChange,
        notifyOwnerId,
        notifySubId,
        notifyOwnerValue,
        notifySubValue,
    } = props;

    const handleOwnerChange = async (e: CheckboxChangeEvent) => {
        onOwnerChange(
            notifyOwnerId,
            e.target.checked
                ? SpecificationOwnerShareMode.SharedWithAllOwners
                : SpecificationOwnerShareMode.NotShared,
        );
    };

    const handleSubChange = async (e: CheckboxChangeEvent) => {
        onSubChange(
            notifySubId,
            e.target.checked
                ? SpecificationSubShareMode.SharedWithAllSubs
                : SpecificationSubShareMode.NotShared,
        );
    };

    return (
        <div className="flex flex-col gap-2">
            <div className="flex flex-row">
                <BTCheckbox
                    data-testid="notifyOwners"
                    id="notifyOwners"
                    indeterminate={notifyOwnerValue === null}
                    checked={notifyOwnerValue === SpecificationOwnerShareMode.SharedWithAllOwners}
                    onChange={handleOwnerChange}
                >
                    Clients
                </BTCheckbox>
            </div>
            <div className="flex flex-row">
                <BTCheckbox
                    data-testid="notifySubs"
                    id="notifySubs"
                    indeterminate={notifySubValue === null}
                    checked={notifySubValue === SpecificationSubShareMode.SharedWithAllSubs}
                    onChange={handleSubChange}
                >
                    Subs/vendors
                </BTCheckbox>
            </div>
        </div>
    );
}
